module.exports = __webpack_public_path__ + "media/images/badges/kinrgy/Kinrgy-500-Classes-Inactive-73045b3ad5f9abc3cf26e4974d61d35b.png";